import styled from 'styled-components'
import {
    svgStroke,
    belowTablet, belowPhone
} from 'utilities/styled'
import { Grid } from 'components/grid'
import ModuleTitleBase from 'components/module-title'
import SigningPanelBase from 'pages/documents/panels/signing'
import { ParagraphSmall } from 'components/typography/paragraph'

export const LimitStatusWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 8px;
`

export const HeroGrid = styled.div`
    display: grid;
    grid-template-columns:
        [title] 1fr
        [signing] auto
        [actions] 40px;
    gap: 16px;

    &:not(.slim) {
        margin-block-end: 40px;
    }

    &.slim {
        margin-block-end: 16px;
    }

    & + ${LimitStatusWrapper} {
        margin-block-end: 24px;
    }

    ${belowTablet`
        grid-template-columns:
            [title signing] 1fr
            [actions] 40px;

        margin-block-end: 24px;
    `}

    ${belowPhone`
        &.has-selected {
            display: none;
        }
    `}
`

export const ModuleTitle = styled(ModuleTitleBase)`
    grid-column: title;
`

export const SigningPanel = styled(SigningPanelBase)`
    grid-column: signing;

    ${belowTablet`
        grid-row: 2;
    `}
`

export const TextColumns = styled(ParagraphSmall)`
    display: grid;
    grid-auto-columns: auto;
    grid-auto-flow: column;
    gap: 16px;
    align-items: center;
`

export const LabelProgress = styled(Grid)`
    grid-auto-rows: auto;
    grid-auto-flow: row;
    grid-row-gap: 8px;
`

export const Label = styled(Grid)`
    grid-auto-columns: auto;
    grid-auto-flow: column;
    justify-content: start;
    align-items: center;
    grid-column-gap: 8px;

    svg {
        ${svgStroke('small')}
    }
`

export const ActionColumn = styled.div`
    position: relative;

    grid-row: 1 / -1;
    grid-column: actions;
`